import React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IPrintPurchaseOrderDialogProperties } from './PrintDialog.properties';
import PrintSchema from './PrintDialog.form';
import { useSetDefaultOptions, useUpdateOptions } from 'api/documentOutput';
import { IDocumentOutputOptionsFacade } from 'api/swaggerTypes';
import { Inline } from 'api/utils';

const PrintDialog = (props: IPrintPurchaseOrderDialogProperties) => {
    const { open, loading, onCancel, programId, documentType, fieldId, entityCode, setPrintOutputOptions, printOutputOptions, clearPrintOutputOptions, customerId, supplierId } = props;
    const useDefaultOptionMutation = useSetDefaultOptions();

    const [initialValues, setInitialValues] = React.useState<IDocumentOutputOptionsFacade>();
    const [valuesSchema, setValuesSchema] = React.useState<Inline<IDocumentOutputOptionsFacade>>();

    const applyOutputOptionsMutation = useUpdateOptions();

    React.useEffect(
        () => {
            if (programId && open) {
                fetchDefaultPrintOptions();
            } else {
                clearPrintOutputOptions();
            }
        },
        [programId, open]
    );

    const fetchDefaultPrintOptions = React.useCallback(
        async () => {
            if (programId !== undefined && programId !== null && programId !== '' && programId.toString() !== 'NaN') {
                try {
                    const response = await useDefaultOptionMutation.mutateAsync(
                        {
                            DocumentType: documentType,
                            FieldId: fieldId,
                            documentCode: documentType,
                            entityCode: entityCode,
                            keyId: programId,
                            businessObjectId: ''
                        });

                    if (response?.Status && !response?.Forms) {
                        setInitialValues(response?.DocumentOutputOptions?.inlineObject);
                        setPrintOutputOptions(response?.DocumentOutputOptions?.inlineObject);
                        setValuesSchema(response?.DocumentOutputOptions?.schema);
                    } else {
                        setInitialValues(undefined);
                        setPrintOutputOptions(undefined);
                        setValuesSchema(undefined);
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        },
        [programId, entityCode]
    );

    const printOrder = React.useCallback(
        async (data) => {
            if (data) {
                try {
                    const response = await applyOutputOptionsMutation.mutateAsync({
                        KeyId: programId,
                        Entity: entityCode,
                        TTDocout: { ...data },
                        urlQueryParams: {
                            SendDocument: true
                        }
                    });

                    if (response?.Status) {
                        onCancel();

                        return response?.Status;
                    }

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }

            return false;
        },
        [programId, entityCode]
    );

    const applySettings = async () => {
        const resp = await printOrder({ ...printOutputOptions });

        return resp;
    };

    return (
        <div>
            <FormViewModal
                open={open}
                loading={loading}
                title='Print'
                formProps={{
                    formSchema: PrintSchema,
                    initialValues: {
                        ...initialValues,

                    },
                    customerId: customerId || 0,
                    supplierId: supplierId || 0,
                    valuesSchema: valuesSchema ? valuesSchema : {},
                    style: { height: '150px', minWidth: '600px' },
                    fieldExtensions: ({
                        DocumentOutputOptions: {
                            props: {
                                onApplySettings: applySettings,
                                onCancelDialog: () => {
                                    if (onCancel) {
                                        onCancel();
                                    }
                                    clearPrintOutputOptions();
                                },
                                bypassPopup: true,
                                fieldId: fieldId,
                                documentType: documentType,
                                isProcessing: applyOutputOptionsMutation.isLoading
                            }
                        }
                    })
                }}
                actions={[
                    {
                        title: 'Ok',
                        disabled: applyOutputOptionsMutation.isLoading,
                        listener: () => {
                            printOrder({ ...printOutputOptions });
                        }
                    },
                    {
                        title: 'Cancel',
                        isDefault: true,
                        listener: () => {
                            if (onCancel) {
                                onCancel();
                            }
                        },
                    },
                ]}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
            />
        </div>
    );
};

export default PrintDialog;
